// extracted by mini-css-extract-plugin
module.exports = {"main":"AnimateInContainer_main__4mCHh"};